const solrFields = {
    archive: "archive_ss",
    section: "section_s",
    volume: "volume_s",
    person: "person_ss",
    project: "project_ss",
    title: "title"
};

function captionSort(a, b, substringIndex = 0) {
    return a.caption.substring(substringIndex).localeCompare(b.caption.substring(substringIndex));
}

function subFacetExists(that, caption, values) {
    const parsedCaption = that.parseFacetName(caption);
    if(values.some((c) => {
        const p = that.parseFacetName(c);
        if(p.hierarchyLevel > parsedCaption.hierarchyLevel
            && p.facetNameString.substring(2).startsWith(parsedCaption.facetNameString.substring(2))
            && p.facetNameString.length > parsedCaption.facetNameString.length
            ){
                return true;
            } else {
                return false
            }
        }
    )) {
        return true;
    } else {
        return false;
    }
}

module.exports = {
    keys : ["archiv", "abt", "band", "person", "project", "title"],

    countSort(a, b) {
        return b.count - a.count || captionSort(a, b);
    },

    sectionSort(a, b) {
        return captionSort(a, b, 2);
    },

    filterQuery(query, filters) {
        return {
            q: query.q,
            ...filters
        };
    },

    model(key, values, sort, filters, isHierarchical = false, isFilterable = false) {
        if(values) {
            let model = {
                expanded: isHierarchical,
                hidden: false,
                selected: (filters && filters[key]) ? true : false,
                filterString: "",
                isFilterable,
                isHierarchical,
                key: key,
                name: this.names[key],
                values: Object.keys(values)
                    .map(value => [value, values[value]])
                    .filter(([, count]) => count > 0)
                    .map(([value, count]) => ({
                        count,
                        facet: key,
                        caption: value,
                        selected: (filters && filters[key] && filters[key].includes(value)) ? true : false,
                    }))
                    .sort(sort)
            }
            if(isHierarchical) {
                for(const v of model.values) {
                    if(subFacetExists(this, v.caption, model.values.map((v) => v.caption))) {
                        v.hierarchyOpen = true;
                    } else {
                        v.hierarchyOpen = false;
                    }
                }
            }
            return model;
        } else {
            return {};
        }
    },

    parseFacetName(facetNameString) {
        // first disjunction captures hierarchic facet names, starting with a number, followed by a path expression, e. g. "1/Berliner Chronik/Manuskripte"
        // second disjunction captures non-hierarchic facet names, "Blumeshof 12"
        const facetNameMatch = facetNameString.match(/^(\d)?\/(.+\/)*(.+)|^(.)([^/])(.*)$/);
        return {
            facetNameString,
            hierarchyLevel: Number(facetNameMatch[1]),
            hierarchyPath: facetNameMatch[2],
            hierarchyLeaf: facetNameMatch[3],
            isHierarchicFacet: facetNameMatch[1] && facetNameMatch[1].length > 0,
            nonHierarchicFacetName: facetNameMatch[4] ? facetNameMatch[4] + facetNameMatch[5] + facetNameMatch[6] : ""
        }
    },

    names: {
        archiv: "Archiv",
        abt: "Abteilung",
        band: "Band",
        person: "Personen",
        project: "Werkprojekte",
        title: "Werktitel"
    },

    solrFields: solrFields
}
